module.exports = __webpack_public_path__ + "img/31.043b59a6.png";